'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _uiImages = require('ui-images');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _omit = require('../utils/underscore/omit');

var _omit2 = _interopRequireDefault(_omit);

var _UIImage = require('./UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _BrowserTest = require('../utils/BrowserTest');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var validateDimensions = function validateDimensions(_ref) {
  var height = _ref.height,
      width = _ref.width;

  if (height == null && width == null) {
    _devLogger2.default.warn({
      message: 'UIAbstractIllustration: Provide either width or height prop to ensure proper scaling.',
      key: 'UIAbstractIllustration-dimensions-none'
    });
    return;
  }

  if (height != null && width != null) {
    _devLogger2.default.warn({
      message: 'UIAbstractIllustration: Setting both width and height may not behave as expected.',
      key: 'UIAbstractIllustration-dimensions-both'
    });
  }
};

var getClassNames = function getClassNames(className, disabled) {
  return (0, _classNames2.default)(className, 'private-illustration', {
    'private-illustration--disabled': disabled
  });
};

exports.default = _react2.default.createClass({
  displayName: 'UIAbstractIllustration',

  propTypes: _extends({}, (0, _omit2.default)(_UIImage2.default.propTypes, 'src', 'responsive'), {
    disabled: _react.PropTypes.bool,
    height: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
    name: _react.PropTypes.string,
    width: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
    _getImageUrlFromName: _react.PropTypes.func.isRequired
  }),

  getDefaultProps: function getDefaultProps() {
    return _extends({}, (0, _omit2.default)(_UIImage2.default.defaultProps, 'responsive'), {
      _getImageUrlFromName: function _getImageUrlFromName(name) {
        return (0, _uiImages.getImageUrl)(name, undefined, (0, _BrowserTest.isIE11)());
      }
    });
  },
  componentWillMount: function componentWillMount() {
    validateDimensions(this.props);
  },
  componentWillUpdate: function componentWillUpdate(nextProps) {
    validateDimensions(nextProps);
  },
  render: function render() {
    var _props = this.props,
        className = _props.className,
        disabled = _props.disabled,
        name = _props.name,
        _getImageUrlFromName = _props._getImageUrlFromName,
        rest = _objectWithoutProperties(_props, ['className', 'disabled', 'name', '_getImageUrlFromName']);

    return _react2.default.createElement(_UIImage2.default, _extends({}, rest, {
      responsive: false,
      className: getClassNames(className, disabled),
      objectFit: 'contain',
      src: _getImageUrlFromName(name)
    }));
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/image/UIAbstractIllustration.js
// module id = 502
// module chunks = 3 4 5